$(document).ready(function(){
  $('.feature_wrapper').slick({
    slidesToShow: 6,   
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,     
    dots: false,       
    responsive: [
      {
        breakpoint: 1150,
        settings: { slidesToShow: 4 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 400,
        settings: { slidesToShow: 1 }
      }
    ]
  });

  // $(".menu-drawer__menu-item--parent").on("click", function (e) {
  //   e.preventDefault();

  //   const $submenu = $(this).next(".menu-drawer__menu--grandchildlist");

  //   $(this).toggleClass("is-open");
  //   $submenu.toggleClass("open");
  // });

    var quantitySelector = $(".product-page .buy-buttons-block .product-form-buttons .quantity-selector");
    var addToCartButton = $(".product-page .buy-buttons-block .product-form-buttons .button.add-to-cart-button");
    quantitySelector.insertAfter(addToCartButton);

});


// product card remove text after Dash
document.addEventListener("DOMContentLoaded", function () {
  function cleanProductTitles() {
    document.querySelectorAll(".product-card__content a.contents.user-select-text .spacing-style p, .predictive-search-results__card ").forEach(function (el) {
      let fullText = el.innerText.trim();
      if (fullText.includes("–")) {
        el.innerText = fullText.split("–")[0].trim();
      } else if (fullText.includes("-")) {
        el.innerText = fullText.split("-")[0].trim();
      }
    });
  }

  // Run once after load
  cleanProductTitles();

  // Run again if new products are dynamically added (optional but useful)
  const observer = new MutationObserver(() => cleanProductTitles());
  observer.observe(document.body, { childList: true, subtree: true });
});


// review app
const intervalId = setInterval(() => {
  const jdgmRevBodies = document.querySelectorAll('.jdgm-rev .jdgm-rev__body');
  const jdgmProfiles = document.querySelectorAll('.jdgm-rev .jdgm-row-profile');

  if (jdgmRevBodies.length && jdgmProfiles.length) {
    jdgmRevBodies.forEach((body, index) => {
      const profile = jdgmProfiles[index];
      if (profile && profile.nextElementSibling !== body) {
        profile.insertAdjacentElement('afterend', body);
      }
    });
  }
}, 100);

const moveBadge = setInterval(() => {
  const badge = document.querySelector(".jdgm-preview-badge--with-link");
  const target = document.querySelector("a.contents.user-select-text.product-title-div");

  if (badge && target) {
    target.insertAdjacentElement("afterend", badge);
    clearInterval(moveBadge);
  }
}, 100);


// price insert before
setTimeout(function() {
  $(".product-price-size-guide-main").insertBefore(".buy-buttons-block");
  $(".jatko, .loader, .overlay").fadeOut();
}, 10); // 1000 ms = 1 second

// price shipping box
$( ".buy-buttons-block" ).after( $( ".cf-kk-proinfo.product-shipping-info" ) );


// buybox shipping box
$(document).ready(function() {
  var $aboutInfo = $(".cf-kk-about-product-info");
  var $originalParent = $aboutInfo.parent();

  function moveProductInfo() {
    if ($(window).width() <= 767) {
      $aboutInfo.insertAfter(".product-info-wrap");
    } else {
      $aboutInfo.appendTo($originalParent);
    }
  }
  moveProductInfo();
  $(window).on("resize", function() {
    moveProductInfo();
  });
});

// specific
$('p').each(function() {
  if ($(this).html().trim() === '&nbsp;' || $(this).html().trim() === '') {
    $(this).hide();
  }
});


// menu hove and on click
$(document).ready(function() {

$(".menu-list__link").on("click", function(e) {
  const $submenu = $(this).siblings(".menu-list__submenu");

  if ($submenu.length) {
    if (!$submenu.hasClass("show")) {
      e.preventDefault();
      e.stopPropagation();

      $(".menu-list__submenu").not($submenu).removeClass("show");
      $submenu.addClass("show");
    }
    // biji vaar click karse to normal redirect thay
  }
});
});


// changes dropdown
jQuery(document).ready(function($) {
  var $select = $('.variant-option__select');
  function updateBodyClass() {
    var $firstOption = $select.find('option:first');
    if ($firstOption.is(':selected')) {
      $('body').addClass('first-option-selected');
    } else {
      $('body').removeClass('first-option-selected');
    }
  }
  // Run on page load
  updateBodyClass();
  // Run when user changes dropdown
  $select.on('change', updateBodyClass);
});